






import Vue from 'vue';
import { Modal, ModalMixin } from 'mycorems-app-shared';
import SubscribedUsersTable from './SubscribedUsersTable.vue';

export default Vue.extend({
  mixins: [ModalMixin],
  props: {
    accountId: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  components: {
    Modal,
    SubscribedUsersTable,
  },
});
